import { useState } from 'react';

import { Alert, Button, Descriptions, Input } from 'antd';
import { T, TF } from 'react-translator-component';

import * as S from './styled';

import { getOcpiToken, OcpiTokenResult } from '../../../hooks/ocpi';

const TokenTab = () => {
  const [uid, setUid] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<OcpiTokenResult & { uid: string }>();

  const lookup = async () => {
    const value = uid.trim();
    if (!value) return;
    setLoading(true);
    setResult({ ...(await getOcpiToken(value)), uid: value });
    setLoading(false);
  };

  return (
    <S.Panel style={{ maxWidth: 720 }}>
      <h2>{T('Look up OCPI token')}</h2>
      <p style={{ color: '#717171' }}>{T('Enter the UID of the token the partner sent to see the linked tag in the CS.')}</p>
      <label htmlFor="ocpi-token-uid">{T('Token UID')}:</label>
      <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
        <Input
          id="ocpi-token-uid"
          value={uid}
          onChange={(e) => setUid(e.target.value)}
          onPressEnter={lookup}
          placeholder={TF('E.g.: 04A2B7719C81')}
          style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace' }}
        />
        <Button type="primary" loading={loading} onClick={lookup}>
          {T('Look up')}
        </Button>
      </div>

      {result?.found && result.token && (
        <Descriptions size="small" column={3} bordered style={{ marginTop: 16 }}>
          <Descriptions.Item label={T('OCPI UID')}>
            <S.Mono>{result.token.token_uid}</S.Mono>
          </Descriptions.Item>
          <Descriptions.Item label={T('Tag in the CS')}>
            <S.Mono>{result.token.ocpp_tag_id}</S.Mono>
          </Descriptions.Item>
          <Descriptions.Item label={T('Type')}>OCPI</Descriptions.Item>
        </Descriptions>
      )}
      {result && !result.found && (
        <Alert
          style={{ marginTop: 16 }}
          type={result.notFound ? 'warning' : 'error'}
          message={
            result.notFound
              ? `${TF('No OCPI token with the UID')} ${result.uid}. ${TF('Check whether the partner has already sent the token.')}`
              : TF('Could not look up the token. Try again in a few minutes.')
          }
        />
      )}
    </S.Panel>
  );
};

export default TokenTab;
